import { CurrentQuotaCard } from '../../components/CurrentQuotaCard'
import { QuotaHistoryListing } from '../../components/QuotaHistoryListing'

export default function QuotaPage() {
	return (
		<div className="space-y-6 p-6">
			<div className="space-y-1">
				<h1 className="text-2xl font-bold">จัดการโควต้า</h1>
				<p className="text-sm text-muted-foreground">
					ดูข้อมูลโควต้าปัจจุบันและประวัติการซื้อโควต้า
				</p>
			</div>

			<CurrentQuotaCard />
			<QuotaHistoryListing />
		</div>
	)
}
